import { EnhancedTrackInfo } from "./EnhancedTrackInfo";
import { PlayerControls } from "./PlayerControls";
import { PlayerActionControls } from "./PlayerActionControls";
import { Track } from "@/types";

interface PlayerExpandedMobileProps {
  currentTrack: Track;
  isPlaying: boolean;
  liked: boolean;
  sponsorName?: string | null;
  sponsorUsername?: string | null;
  sponsorAvatar?: string | null;
  volume: number;
  currentTime: number;
  onToggleLike: () => void;
  onTogglePlayPause: () => void;
  onVolumeChange: (value: number[]) => void;
  onSeek: (value: number[]) => void;
  formatTime: (timeInSeconds: number) => string;
}

export function PlayerExpandedMobile({
  currentTrack,
  isPlaying,
  liked,
  sponsorName,
  sponsorUsername,
  sponsorAvatar,
  volume,
  currentTime,
  onToggleLike,
  onTogglePlayPause,
  onVolumeChange,
  onSeek,
  formatTime,
}: PlayerExpandedMobileProps) {
  return (
    <div className="flex flex-col space-y-6">
      {/* Track Details - Optimized for mobile */}
      <EnhancedTrackInfo
        track={currentTrack}
        sponsorName={sponsorName}
        sponsorUsername={sponsorUsername}
        sponsorAvatar={sponsorAvatar}
        liked={liked}
        onToggleLike={onToggleLike}
      />

      {/* Player Controls — sized to their own content now that the sheet
          itself only extends as tall as it needs to, instead of a flex-1 +
          justify-center pair that used to center these inside a container
          forced to fill the whole screen. */}
      <div className="w-full max-w-sm mx-auto space-y-8">
        <PlayerControls
          isPlaying={isPlaying}
          togglePlayPause={onTogglePlayPause}
          currentTime={currentTime}
          duration={currentTrack.duration}
          onSeek={onSeek}
          formatTime={formatTime}
        />
        <PlayerActionControls volume={volume} onVolumeChange={onVolumeChange} />
      </div>
    </div>
  );
}
